import initForm from '../form/FormInitializer';
import FormConfigProps from '../../model/form/FormConfigProps';
import TanInputForm from '../../components/compositions/mfa/TanInputForm';

const createFieldMap = (state, props) => ({
  mfaTan: {
    name: 'tan',
    label: props.ui.mfaTanSmsFieldMfaTanLabel,
    type: 'mfaTan',
    validation: {
      isRequired: true,
    },
  },
});

// init component once, outside
const component = initForm()(TanInputForm);

export const id = 'data';

/**
 * @return {FormConfig}
 */
export const mapStateToFormConfig = (state, props) => {
  const { form, ui } = props;
  const fieldMap = createFieldMap(state, props);
  const { mfaTan } = fieldMap;
  const hasInputError = !!state.form?.[form]?.syncErrors?.[mfaTan.name];
  const isTouched = !!state.form?.[form]?.values;
  const hasSubmitError = !!state.form?.[form]?.error;
  const isValid = state.form?.[form]?.values?.tan?.length === 6;
  const isSubmitDisabled = hasInputError || hasSubmitError || !isTouched || !isValid;

  const { user } = state;

  return {
    id,
    component,
    fieldMap,
    user,
    formConfigProps: new FormConfigProps({
      labelSubmit: ui.mfaTanSubmit,
      withRequiredHint: false,
      labelCancel: ui.mfaTanCancel,
      isSubmitDisabled,
    }),
  };
};

export default mapStateToFormConfig;
